import React, { FunctionComponent } from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { UseStore } from "../store";

type PrivateRouteProps = RouteProps & {
  render: FunctionComponent;
  fallbackTo: string;
};

export const PrivateRoute = ({
  render: RenderProp,
  fallbackTo,
  ...rest
}: PrivateRouteProps) => {
  return (
    <Route
      {...rest}
      render={() => (
        <UseStore name="auth" item="user">
          {(user = {}) => {
            if (Object.keys(user || {}).length === 0) {
              return <Redirect to={fallbackTo} />;
            }
            return <RenderProp />;
          }}
        </UseStore>
      )}
    />
  );
};
